// Project status is stored as an enum (IN_PROGRESS) and must never reach the
// screen in that form. Every place that shows a project's status goes through
// here, so a new status added to the backend is labelled once, not in each
// page that happens to render it.
//
// Assignment statuses have their own map in formatAssignmentStatus.js — they
// are a different set ("Not Started", "Needs Rework") and deliberately stay
// separate.

export const PROJECT_STATUS_OPTIONS = [
  { value: "PENDING", label: "Pending" },
  { value: "IN_PROGRESS", label: "In Progress" },
  { value: "COMPLETED", label: "Completed" },
  { value: "ON_HOLD", label: "On Hold" },
  { value: "AWAITING_INVOICE", label: "Awaiting Invoice" },
];

const PROJECT_STATUS_LABELS = PROJECT_STATUS_OPTIONS.reduce((acc, option) => {
  acc[option.value] = option.label;
  return acc;
}, {});

/**
 * Human label for a project status. An unmapped value is title-cased rather
 * than passed through, so an enum the frontend has not been taught yet still
 * reads as "Some Status" instead of SOME_STATUS.
 */
export function formatProjectStatus(status) {
  if (!status) return "-";
  if (PROJECT_STATUS_LABELS[status]) return PROJECT_STATUS_LABELS[status];
  return String(status)
    .toLowerCase()
    .split(/[_\s]+/)
    .filter(Boolean)
    .map((word) => word[0].toUpperCase() + word.slice(1))
    .join(" ");
}
